import { getDaysOfWeek } from "@lhd/utility";
import { Styles } from "./styled";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { DATE_TIME_FORMAT } from "@lhd/constants";
interface IProps {
  onChange: (dateString: string) => void;
  dateDefaultActive?: string;
  className?: string;
}

const normalizeDate = (value?: string) => {
  if (!value) return dayjs().format(DATE_TIME_FORMAT.DATE_DEFAULT);
  const normalized = value.trim().replace(/-/g, "/");
  const d = dayjs(normalized);
  return d.isValid() ? d.format(DATE_TIME_FORMAT.DATE_DEFAULT) : normalized;
};

const WeekChoose = (props: IProps) => {
  const { dateDefaultActive, onChange, className } = props;
  const [dateActive, setDateActive] = useState(() =>
    normalizeDate(dateDefaultActive),
  );

  const daysOfWeek = useMemo(
    () => getDaysOfWeek(dayjs(dateActive)),
    [dateActive],
  );

  useEffect(() => {
    const next = normalizeDate(dateDefaultActive);
    if (next !== dateActive) {
      setDateActive(next);
    }
  }, [dateActive, dateDefaultActive]);

  useEffect(() => {
    onChange(dateActive);
  }, [dateActive, onChange]);

  return (
    <Styles className={className || ""}>
      {daysOfWeek.map((x) => {
        const isActive = x.date === dateActive;
        return (
          <div
            className="container-day-item"
            key={x.day}
            // onClick={() => {
            //   setDateActive(x.date);
            // }}
          >
            <div className="weekday-as-title">{x.weekdayJP}</div>
            <div className={`weekday ${isActive ? "active" : ""}`}>{x.day}</div>
          </div>
        );
      })}
    </Styles>
  );
};
export default WeekChoose;
